import { AuthContext } from "@/iti-core-react/contexts/auth";
import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import { ItiMessageService } from "@/iti-core-react/services/iti-message-service";
import ShowLegalConditionsPopup from "@/pages/ShowLegalConditionsPopup/ShowLegalConditionsPopup";
import { useCallback, useContext } from "react";
import { useAuth } from "../LoginAuth";

const conditionClauseId = "REGISTER_USER_TERMS";
export const legalConditionsPopup = "LEGAL_CONDITIONS_POPUP";

interface LegalConditionsPopupLoginProps {
	onSubmit: (e: any) => void;
	onHideLegalConditionsPopUp: () => void;
}

export function LegalConditionsPopupLogin({
	onHideLegalConditionsPopUp,
	onSubmit,
}: Readonly<LegalConditionsPopupLoginProps>) {
	const {
		isAuthenticated,
		conditionClauses,
		setConditionClauses,
		validateUser,
		createConditionClauseResourceUser,
		setLegalConditionsPopupVisible,
	} = useAuth();
	const { t } = useLanguage();
	const { signIn, signOut } = useContext(AuthContext);

	const loginErrorMessage = t("login.error");

	function onHideLegalConditions() {
		signOut?.();
		onHideLegalConditionsPopUp();
	}

	// Aceptación de cláusulas y condiciones y login
	const onAcceptClausesAndLogin = useCallback(async () => {
		if (conditionClauses) {
			const promises = conditionClauses.conditionClauseList.map(
				(clauseCondition: any) => {
					return createConditionClauseResourceUser(clauseCondition);
				},
			);

			const responses = await Promise.all(promises);

			if (
				responses &&
				responses.length === conditionClauses.conditionClauseList.length
			) {
				// Validar el usuario
				const isValid = await validateUser();

				if (isValid) {
					setLegalConditionsPopupVisible(false);
					// Realiza el login
					onSubmit(legalConditionsPopup);
				} else {
					ItiMessageService.toastError(t("terms-condition.error"));
					if (signOut) {
						signOut();
					}
				}
			} else {
				ItiMessageService.toastError(t("terms-condition.error"));
			}
		}
	}, [
		isAuthenticated,
		conditionClauses,
		loginErrorMessage,
		createConditionClauseResourceUser,
		signIn,
		signOut,
		validateUser,
		t,
	]);

	return (
		<ShowLegalConditionsPopup
			conditionClauseId={conditionClauseId}
			onHide={onHideLegalConditions}
			onAccept={onAcceptClausesAndLogin}
			onConditionsLoaded={setConditionClauses}
		/>
	);
}
